<div class="wrapper-group-access-card" [style.color]="wrapperInfo?.color">
  <div>
    <div class="header-template">
      <div class="header-template-left">
        <img
          [src]="wrapperInfo?.logoHeader"
          alt="lex-logo"
          class="header-logo-template"
        />
      </div>
      <div class="header-template-right">
        <span class="header-school-name">{{ cardList[0]?.schoolName }}</span>
      </div>
    </div>
  </div>
  <div class="mb-32">
    <span class="header-title-template">{{ cardList[0]?.className }}</span>
  </div>
  <div>
    <div class="card-list-container">
      <div *ngFor="let card of cardList; let i = index">
        <seb-access-card
          [cardInfo]="card"
          [userCardAssets]="wrapperInfo"
        ></seb-access-card>
        <div
          *ngIf="showHeaderTemplateAfterSixCards(i, cardList)"
          class="header-template-after-six-cards"
          [ngStyle]="{
            'margin-top': calculateMarginTop(i) + 'px'
          }"
        >
          <div class="header-template">
            <div class="header-template-left">
              <img
                [src]="wrapperInfo?.logoHeader"
                alt="lex-logo"
                class="header-logo-template"
              />
            </div>
            <div class="header-template-right">
              <span class="header-school-name">{{
                cardList[0]?.schoolName
              }}</span>
            </div>
          </div>
          <div class="mb-32">
            <span class="header-title-template">{{
              cardList[0]?.className
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
